export default class Transition {
	constructor(startNode, nextNode, requirement) {
		this.name = `${startNode} => ${nextNode}`;
		this.startNode = startNode;
		this.nextNode = nextNode;
		this.requirement = requirement;
	}
}
